import type { GatesAttention } from "@/features/administration/api/administration.api";

/**
 * True only for a gates read that SUCCEEDED and found nothing to show. A
 * truncated scan is never "empty": the unscanned gates are unknown.
 */
export function gatesAttentionIsEmpty(gates: GatesAttention): boolean {
  return (
    gates.needsYourDecision.length === 0 &&
    gates.noEligibleApprover.length === 0 &&
    gates.awaitingOthersCount === 0 &&
    gates.notEvaluableCount === 0 &&
    !gates.truncated
  );
}
